import { REDUX } from 'constants/index';
import { getReducer } from '../lib/reducerCreator';
import { combineReducers } from 'redux';

const reducers = getReducer(REDUX.DIALOGS, '');

export default combineReducers({ ...reducers });
